import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ViewIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ViewIcon = ({ strokeWidth, ...props }: ViewIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={true}
    width="24"
    height="24"
    viewBox="0 0 18 14"
    fill="none"
    strokeWidth={strokeWidth}
    {...props}
  >
    <g
      strokeWidth={strokeWidth || 2}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M1.5 7C1.5 7 4.5 1.5 9 1.5C13.5 1.5 16.5 7 16.5 7C16.5 7 13.5 12.5 9 12.5C4.5 12.5 1.5 7 1.5 7Z" />
      <path d="M9 9.5C10.3807 9.5 11.5 8.38071 11.5 7C11.5 5.61929 10.3807 4.5 9 4.5C7.61929 4.5 6.5 5.61929 6.5 7C6.5 8.38071 7.61929 9.5 9 9.5Z" />
    </g>
  </BaseIcon>
);

ViewIcon.displayName = 'ViewIcon';
